// @generated
// This file is automatically generated by Kanel. Do not modify manually.

/** Represents the enum public.dataset_synthesis_status */
enum DatasetSynthesisStatus {
  not_started = 'not_started',
  queued = 'queued',
  running = 'running',
  completed = 'completed',
  failed = 'failed',
};

export default DatasetSynthesisStatus;
